"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectScript = exports.findScript = void 0;

const findScript = url => document.querySelector(`script[src^="${url}"]`);

exports.findScript = findScript;

const injectScript = url => {
  const script = document.createElement('script');
  script.src = url;
  const parent = document.head || document.body;

  if (!parent) {
    throw new Error('No <head> or <body> elements found in document.');
  }

  parent.append(script);
  return script;
};

exports.injectScript = injectScript;